export default __webpack_public_path__ + "static/media/blank.191fbc75.png";